import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useEffect, useRef } from "react";
import "./Confirmation.css";

export default NiceModal.create(
    ({
        content,
        title,
        component,
        onConfirmClick,
        onCancelClick,
        confirmButtonText,
        rejectButtonText,
        hideConfirmRejectButtons = false,
    }) => {
        const modal = useModal();
        const dialogRef = useRef(null);

        const handleModal = (e) => {
            if (e.key === "Escape") {
                modal.remove();
            }
        };

        //NOTE: Ref in use here to invoke showDialog, which will allow the triggering
        //of the pseudo-element ::backdrop for the <dialog> element.
        useEffect(() => {
            let refCopy = null;
            console.log("load confirmation dialog");

            dialogRef.current.addEventListener("keydown", handleModal);
            dialogRef.current.showModal();
            refCopy = dialogRef.current;

            return () => {
                if (refCopy) {
                    console.log("unload confirmation dialog");
                    refCopy.removeEventListener("keydown", handleModal);
                }
            };
        }, []);

        return (
            <dialog ref={dialogRef}>
                <header className="dialog-title">
                    {title}
                    {/* <div onClick={() => {
                        modal.remove();
                    }}>X</div> */}
                </header>
                <main className="dialog-content">{content}</main>
                <div>{component}</div>
                {hideConfirmRejectButtons === false ? (
                    <footer className="dialog-buttons">
                        <button
                            className="btn btn-primary btn-lg btn-success bold"
                            onClick={() => {
                                modal.resolve({
                                    isConfirmed: true,
                                });
                                modal.remove();
                            }}
                        >
                            {confirmButtonText == null ? "Yes" : confirmButtonText}
                        </button>
                        <button
                            className="btn btn-secondary btn-lg btn-danger pull-right"
                            onClick={() => {
                                modal.resolve({
                                    isConfirmed: false,
                                });
                                modal.remove();
                            }}
                        >
                            {rejectButtonText == null ? "No" : rejectButtonText}
                        </button>
                    </footer>
                ) : (
                    ""
                )}
            </dialog>
        );
    }
);
